import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../ui/card.tsx';
import { Settings } from 'lucide-react';
import { Button } from '../../ui/button.tsx';
import { Link } from 'react-router-dom';
import { usePartnerSubAccountCreation } from '../../../hooks/usePartnerSubAccountCreation.ts';

function SetupRequired() {
  const { hasCustomSubscriptionPlans, hasCustomBoostPackPricing, isWhiteLabel, canCreateSubAccounts } = usePartnerSubAccountCreation();

  if(!isWhiteLabel && canCreateSubAccounts) return null;
  return (
    <Card className="border-amber-200 bg-amber-50">
      <CardHeader className="pb-3">
        <CardTitle className="text-amber-800 flex items-center">
          <Settings className="h-5 w-5 mr-2" />
          Setup Required
        </CardTitle>
        <CardDescription className="text-amber-700">
          Before creating sub-accounts, you need to set up your custom pricing:
        </CardDescription>
      </CardHeader>
      <CardContent className="pt-0">
        <div className="space-y-2 mb-4">
          <div className="flex items-center">
            {hasCustomSubscriptionPlans ? (
              <span className="text-green-600">✓</span>
            ) : (
              <span className="text-amber-600">•</span>
            )}
            <span className="ml-2 text-sm">
              {hasCustomSubscriptionPlans 
                ? 'Custom subscription plans created' 
                : 'Create at least one custom subscription plan'
              }
            </span>
          </div>
          <div className="flex items-center">
            {hasCustomBoostPackPricing ? (
              <span className="text-green-600">✓</span>
            ) : (
              <span className="text-amber-600">•</span>
            )}
            <span className="ml-2 text-sm">
              {hasCustomBoostPackPricing 
                ? 'Custom boost pack pricing configured' 
                : 'Configure custom boost pack pricing'
              }
            </span>
          </div>
        </div>
        <Button asChild className="bg-amber-600 hover:bg-amber-700">
          <Link to="/partner/pricing">
            <Settings className="h-4 w-4 mr-2" />
            Go to Custom Pricing
          </Link>
        </Button>
      </CardContent>
    </Card>
  )
}

export default SetupRequired